import type { BlogPost } from './types';

// Example content for the Blog list + post page templates (§11 of
// `docs/TEMPLATE_IMPROVEMENT_RECOMMENDATIONS.md`). Swap these three sample
// posts for real content, or back this file with a headless CMS / MDX — see
// `docs/CMS_ADAPTER.md`.
export const blogContent = {
    title: 'Latest News',
    intro: 'Updates on sourcing, logistics, and quality from across our global network.',
    posts: [
        {
            slug: 'sourcing-quality-standards',
            title: 'How We Vet Every Sourcing Partner',
            excerpt:
                'A behind-the-scenes look at the quality checks every supplier undergoes before a single shipment leaves the origin country.',
            date: '2025-03-04',
            author: 'Quality Team',
            content: [
                'Every new sourcing partner goes through a multi-stage vetting process before a single container leaves the origin country. This starts with a documentation review \u2014 certifications, compliance history, and prior shipment records \u2014 followed by an on-the-ground facility audit.',
                'Only after passing both stages does a partner move into our active sourcing network, where ongoing spot-checks keep standards consistent shipment after shipment.',
            ],
        },
        {
            slug: 'logistics-cold-chain',
            title: 'Keeping the Cold Chain Unbroken, Door to Door',
            excerpt:
                'Temperature-controlled logistics is where most quality is won or lost. Here is how we keep every link of the chain intact.',
            date: '2025-01-22',
            author: 'Logistics Team',
            content: [
                'Temperature excursions are one of the most common causes of quality loss in global food logistics. We track cold-chain integrity at every handoff \u2014 origin cold storage, refrigerated transport, port handling, and final-mile delivery.',
                'Continuous monitoring lets us catch and correct issues before they ever reach a customer\u2019s dock.',
            ],
        },
        {
            slug: 'market-outlook-2025',
            title: '2025 Market Outlook: What Buyers Should Watch',
            excerpt:
                'A brief look at the sourcing and pricing trends shaping global commodity markets this year.',
            date: '2024-12-10',
            author: 'Market Research',
            content: [
                'Global commodity markets continue to be shaped by weather variability in key growing regions, shifting trade policy, and freight-rate volatility.',
                'Buyers who diversify sourcing origins and lock in supply-chain partnerships early tend to weather this volatility with far less disruption.',
            ],
        },
    ] satisfies BlogPost[],
};
